import React, { useEffect, useState } from "react";
import {
  FaTachometerAlt,
  FaUsers,
  FaClipboardList,
  FaTags,
  FaHome,
  FaBell,

  FaListAlt,
  FaInfo,
  FaBlogger,
  FaQuestion,
} from "react-icons/fa";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdListAlt,
  MdManageAccounts,
  MdOutlineAppRegistration,
} from "react-icons/md";

import "./Admin_Sidebar.css";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios"; // Add axios to fetch user role
import {FaMessage, FaSquareLetterboxd } from "react-icons/fa6";

const Sidebar = ({ darkMode, toggleDarkMode, collapsed }) => {
  const [isCSOOpen, setIsCSOOpen] = useState(false);
  const [staffChatUnreadCount, setStaffChatUnreadCount] = useState(0);

  const [isWebContentOpen, setIsWebContentOpen] = useState(false);
  const [userRole, setUserRole] = useState(null); // Track user role
  const location = useLocation();
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/staff/me`,
          { withCredentials: true }
        );
        if (response.data.success) {
          setUserRole(response.data.role);
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      }
    };

    fetchUserRole();
  }, []);
   const fetchStaffChatUnreadCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/chat/staff/unread-counts`,
        { withCredentials: true }
      );
      
      if (response.data?.success) {
        setStaffChatUnreadCount(response.data.unreadCount || 0);
      }
    } catch (error) {
      console.error("Error fetching staff chat unread count:", error);
      setStaffChatUnreadCount(0);
    }
  };

  useEffect(() => {
    fetchStaffChatUnreadCount();
    const interval = setInterval(fetchStaffChatUnreadCount, 300000);
    return () => clearInterval(interval);
  }, []);
  const toggleCsoSubmenu = () => {
    setIsCSOOpen(!isCSOOpen);
  };
  const toggleWebContentSubmenu = () => {
    setIsWebContentOpen(!isWebContentOpen); // Toggle for Web Content submenu
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div
      className={`admin_sidebar ${collapsed ? "collapsed" : ""} ${
        darkMode ? "dark" : "light"
      }`}
    >
      <div className="logo">
        <h2>
          {collapsed ? "FO" : "Finance Office"}
         
        </h2>
         <p className="text-sm">
            {userRole === "admin"
              ? `Staff of ${userRole}`
              : `Staff of ${userRole}`}
          </p>
      </div>

      <div className="scrollable-menu">
        <ul className="menu">
          {userRole === "admin" && (
            <li
              className={`menu-item ${
                isActive("/admin/dashboard") ? "active" : ""
              }`}
            >
              <Link to="/admin/dashboard" className="flex items-center">
                <FaTachometerAlt />
                <span>{!collapsed && "Dashboard"}</span>
              </Link>
            </li>
          )}

          {userRole === "admin" && (
            <li
              className={`menu-item ${
                isActive("/admin/forms") ? "active" : ""
              }`}
            >
              <Link to="/admin/forms" className="flex items-center">
                <FaListAlt />
                <span>{!collapsed && "Forms"}</span>
              </Link>
            </li>
          )}
          {/* <li className="menu-item" onClick={toggleForm}>
            <MdManageAccounts />
            <span>{!collapsed && "Form"}</span>
            {!collapsed &&
              (isFormOpen ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />)}
          </li>
          {!collapsed && isFormOpen && (
            <ul className="submenu">
             

              <li
                className={`menu-item ${
                  isActive("/admin/create_form") ? "active" : ""
                }`}
              >
                <Link to="/admin/create_form" className="flex items-center">
                  <FaFill />
                  <span>{!collapsed && "Create Form"}</span>
                </Link>
              </li>
            </ul>
          )} */}
          {userRole === "admin" && (
            <li
              className={`menu-item ${
                isActive("/admin/all_submission") ? "active" : ""
              }`}
            >
              <Link to="/admin/all_submission" className="flex items-center">
                <FaListAlt />
                <span>{!collapsed && "ALL Submission"}</span>
              </Link>
            </li>
          )}
          {userRole === "admin" && (
            <li
              className={`menu-item ${
                isActive("/admin/list_requests") ? "active" : ""
              }`}
            >
              <Link to="/admin/list_requests" className="flex items-center">
                <FaListAlt />
                <span>{!collapsed && "List Requests"}</span>
              </Link>
            </li>
          )}
          {userRole === "admin" && (
            <li className="menu-item" onClick={toggleCsoSubmenu}>
              <MdManageAccounts />
              <span>{!collapsed && "CSO Management"}</span>
              {!collapsed &&
                (isCSOOpen ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowRight />
                ))}
            </li>
          )}
          {!collapsed && isCSOOpen && (
            <ul className="submenu">
              <li
                className={`menu-item ${
                  isActive("/admin/all_cso") ? "active" : ""
                }`}
              >
                <Link to="/admin/all_cso" className="flex items-center">
                  <MdListAlt />
                  <span>{!collapsed && "All CSOs"}</span>
                </Link>
              </li>
              <li
                className={`menu-item ${
                  isActive("/admin/cso_list") ? "active" : ""
                }`}
              >
                <Link to="/admin/cso_list" className="flex items-center">
                  <MdOutlineAppRegistration />
                  <span>{!collapsed && "Registered CSO"}</span>
                </Link>
              </li>
              <li
                className={`menu-item ${
                  isActive("/admin/user_register") ? "active" : ""
                }`}
              >
                <Link to="/admin/user_register" className="flex items-center">
                  <FaUsers />
                  <span>{!collapsed && "Register CSOs"}</span>
                </Link>
              </li>
            </ul>
          )}
          {userRole === "admin" && (
            <li
              className={`menu-item ${
                isActive("/admin/letter_list") ? "active" : ""
              }`}
            >
              <Link to="/admin/letter_list" className="flex items-center">
                <FaSquareLetterboxd />
                <span>{!collapsed && "Letter"}</span>
              </Link>
            </li>
          )}
          {userRole === "sup_admin" && (
            <li
              className={`menu-item ${
                isActive("/admin/staffs") ? "active" : ""
              }`}
            >
              <Link to="/admin/staffs" className="flex items-center">
                <FaUsers />
                <span>{!collapsed && "Staff"}</span>
              </Link>
            </li>
          )}
          {userRole === "sup_admin" && (

          <li className="menu-item" onClick={toggleWebContentSubmenu}>
            <FaHome />
            <span>{!collapsed && "Web Content"}</span>
            {!collapsed &&
              (isWebContentOpen ? (
                <MdKeyboardArrowDown />
              ) : (
                <MdKeyboardArrowRight />
              ))}
          </li>
          )}
          {!collapsed && isWebContentOpen && (
            <ul className="submenu">
              <li
                className={`submenu-item ${
                  isActive("/admin/service") ? "active" : ""
                }`}
              >
                <Link to="/admin/service" className="flex items-center">
                  <FaClipboardList />
                  Services
                </Link>
              </li>
              <li
                className={`submenu-item ${
                  isActive("/admin/doc") ? "active" : ""
                }`}
              >
                <Link to="/admin/doc" className="flex items-center">
                  <FaTags />
                  Document
                </Link>
              </li>
              <li
                className={`submenu-item ${
                  isActive("/admin/create_contact_info") ? "active" : ""
                }`}
              >
                <Link
                  to="/admin/create_contact_info"
                  className="flex items-center"
                >
                  <FaInfo />
                  Contact
                </Link>
              </li>

              <li
                className={`submenu-item ${
                  isActive("/admin/news_list") ? "active" : ""
                }`}
              >
                <Link to="/admin/news_list" className="flex items-center">
                  <FaBlogger />
                  News
                </Link>
              </li>
              <li
                className={`submenu-item ${
                  isActive("/admin/about_content") ? "active" : ""
                }`}
              >
                <Link to="/admin/about_content" className="flex items-center">
                  <FaBlogger />
                  About Us
                </Link>
              </li>
              <li
                className={`submenu-item ${
                  isActive("/admin/hero") ? "active" : ""
                }`}
              >
                <Link to="/admin/hero" className="flex items-center">
                  <FaBlogger />
                  Hero Slide
                </Link>
              </li>
            </ul>
          )}

          <li
            className={`menu-item ${isActive("/admin/users") ? "active" : ""}`}
          >
            <Link to="/admin/users" className="flex items-center">
              <FaUsers />
              <span>{!collapsed && "Users"}</span>
            </Link>
          </li>

          {/* <li
            className={`menu-item ${
              isActive("/admin/create_userAccount") ? "active" : ""
            }`}
          >
            <Link to="/admin/create_userAccount" className="flex items-center">
              <FaUserEdit />
              <span>{!collapsed && "Create Account"}</span>
            </Link>
          </li> */}

          <li
            className={`menu-item ${
              isActive("/admin/beneficiary_list") ? "active" : ""
            }`}
          >
            <Link to="/admin/beneficiary_list" className="flex items-center">
              <FaUsers />
              <span>{!collapsed && "Beneficiary"}</span>
            </Link>
          </li>
          <li className={`menu-item ${isActive("/admin/chats") ? "active" : ""}`}>
      <Link to="/admin/chats" className="flex items-center">
        <FaMessage />
        <span>{!collapsed && "Chats"}</span>
        {staffChatUnreadCount > 0 && (
          <span className="ml-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
            {staffChatUnreadCount}
          </span>
        )}
      </Link>
    </li>
          <li
            className={`submenu-item ${
              isActive("/admin/notifications") ? "active" : ""
            }`}
          >
            <Link to="/admin/notifications" className="flex items-center">
              <FaBell />
              <span>{!collapsed && "Notifications"}</span>
            </Link>
          </li>
          <li className={`menu-item ${isActive("/admin/faq") ? "active" : ""}`}>
            <Link to="/admin/faq" className="flex items-center">
              <FaQuestion />
              <span>{!collapsed && "FAQ"}</span>
            </Link>
          </li>
          {/* <li>
            <FaCog />
            <span>{!collapsed && "Settings"}</span>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
